import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import authService from "../../Services/authService";
import utils from "../../Utils";
import strings from "../../Utils/strings";
import translate from "../../Utils/translate";
import Widgets from "../../Widgets";
import validator from "validator";
import clinicService from "../../Services/clinicService";
import "./DoctorLogin.css";
import { useTranslation } from "react-i18next";
import { DeviceUUID } from "device-uuid";

function DoctorLogin() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const state = useLocation();
  const [mobileMaxValue, setMobileMaxValue] = useState(8);
  const [mobile, setMobile] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [code, setCode] = useState(state.state != null ? state.state.countryCode : "65");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [phoneErr, setPhoneErr] = useState("");
  const [defaultCountry, setDefaultCountry] = useState(null);

  useEffect(() => {
    validateSession();
  }, []);

  const [deviceId, setDeviceId] = useState("");
  useEffect(() => {
    const deviceUUID = new DeviceUUID().get();
    setDeviceId(deviceUUID);
    validateSession();
  }, []);

  const validateSession = () => {
    // if (authService.getToken()) {
    //     nav(strings.navigation.dashboard);
    // }
  };

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [usernameError, setUsernameError] = useState("");
  const [passError, setPassError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);

  const formDataChangeHandler = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleCheckboxChange = () => {
    setRemember(!remember);
  };

  const handleLogin = async (event) => {
    event.preventDefault();

    const { username, password } = formData;

    if (!validator.isEmail(username)) {
      setUsernameError("Please enter valid email address");
      return;
    } else {
      setUsernameError("");
    }

    let body = {
      email: username,
      password: password,
    };

    try {
      let response = await clinicService.doctorLogin(body);
      setIsLoading(true);
      if (response.status === "success") {
        console.log(response);
        toast.success("Logged In Successfully");
        setTimeout(() => {
          setIsLoading(false);
          authService.setToken(response.data.token);
          // authService.setClinicId(response.data.hospital._id);
          authService.setPhoneNumber(response.data.doctor.phoneNumber);
          authService.setCountryCode(response.data.doctor.countryCode);
          // authService.setHospitalAddress(response.data.hospital.address);
          authService.setClinicName(response.data.doctor.hospital);
          authService.setDoctorName(response.data.doctor.name);
          authService.setIsDoctorLogin(true);
          nav(strings.navigation.dashboard);
          // window.location.reload();
        }, 500);
      } else if (response.status === 401) {
        toast.error("Invalid Credentials");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("An error occurred. Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <>
      <Toaster autoClose="400" position="bottom-center" />
      {isLoading ? <Widgets.CircularLoader /> : ""}
      <div className="detail-container">
        <div>
          <h5 className="login-title">{t("doctorAdminHeading")}</h5>
        </div>
        <form>
          <div className="relative mt-6">
            <div className={"flex "}>
              <input
                onChange={(e) => {
                  formDataChangeHandler(e);
                  setUsernameError("");
                }}
                onKeyDown={(e) => {
                  if (e.key === " ") {
                    e.preventDefault();
                  }
                }}
                type="text"
                name="username"
                id="username"
                className={"bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5"}
                placeholder={t("usernamePlaceholder")}
                required=""
              />
            </div>
            {usernameError ? <span className="errorMsg">{usernameError}</span> : null}
          </div>
          <div className="relative mt-6 ">
            <input
              onChange={(e) => {
                formDataChangeHandler(e);
                setPassError("");
              }}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                }
              }}
              type={showPassword ? "text" : "password"}
              name="password"
              id="password"
              className="!bg-gray-50 !border !border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5 "
              placeholder={t("passwordPlaceholder")}
              required=""
            />
            {passError ? <span className="errorMsg">{passError}</span> : null}
            <span className="absolute right-2 top-[21px] transform -translate-y-1/2 cursor-pointer" onClick={togglePasswordVisibility}>
              {showPassword ? (
                <img className="w-[16px]" src="https://www.svgrepo.com/show/532493/eye.svg" alt="#" />
              ) : (
                <img className="w-[16px]" src="https://www.svgrepo.com/show/532465/eye-slash.svg" alt="#" />
              )}
            </span>

            <div className="flex justify-end mt-4">
              <p className="text-[.8rem] text-gray-400 cursor-pointer w-fit" onClick={() => nav("/doctor-forgot-password")}>
                {t("forgotPassword")}
              </p>
            </div>
          </div>
          <div className="flex items-center">
            <input type="checkbox" name="checkbox" id="checkbox" onChange={handleCheckboxChange} />
            <span className="px-2 text-[.8rem]">{t("rememberMe")}</span>
          </div>
          <button disabled={isLoading} onClick={handleLogin} className="buttonStyle mt-4 w-full text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center">
            {isLoading ? t("loading") : t("login")}
          </button>
        </form>

        <div className="mt-4">
          <button
            type="button"
            className="buttonSecondary mt-2 w-full font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            onClick={() => {
              nav(strings.navigation.hospitalLogin);
            }}
          >
            {t("loginAsHospital")}
          </button>
        </div>
      </div>
    </>
  );
}

export default DoctorLogin;
